import { render } from "./ShapeBuilder.vue?vue&type=template&id=3c4b2c88&scoped=true"
import script from "./ShapeBuilder.vue?vue&type=script&lang=js"
export * from "./ShapeBuilder.vue?vue&type=script&lang=js"

import "./ShapeBuilder.vue?vue&type=style&index=0&id=3c4b2c88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4b2c88"]])

export default __exports__